import { ToggleValue } from 'components/Admin/Shared/Toggle'

export function settingsTotoggleValue(settings, setting: string) {
  if (settings == null) {
    return ToggleValue.PRIVATE
  }

  if (setting in settings) {
    return settings[setting]['isPublic'] === true
      ? ToggleValue.PUBLIC
      : ToggleValue.PRIVATE
  }

  return ToggleValue.PRIVATE
}
